import { CategoryTeaser } from '../CategoryTeaser/CategoryTeaser';
import { CmsAccordion } from '../CmsAccordion/CmsAccordion';
import { CmsDynamicYield } from '../CmsDynamicYield/CmsDynamicYield';
import { CmsGroup } from '../CmsGroup/CmsGroup';
import { CmsHeadline } from '../Headline/Headline';
import { CmsInstallmentCalculator } from '../CmsInstallmentCalculator/CmsInstallmentCalculator';
import { CmsRecommendation } from '../CmsRecommendation/CmsRecommendation';
import { CmsCarousel } from '../CmsCarousel/CmsCarousel';
import { CmsImage } from '../CmsImage/CmsImage';
import { ComponentTypes } from '../../../interfaces/components';
import { CmsEpsRecommendation } from '../CmsEpsRecommendation/CmsEpsRecommendation';
import { ExternalScript } from '../ExternalScript/ExternalScript';
import { HermesShopFinder } from '../HermesShopFinder';
import { Html } from '../Html/Html';
import { LinkByButton } from '../LinkByButton/LinkByButton';
import { LinkBox } from '../LinkBox/LinkBox';
import { LinkByText } from '../LinkByText/LinkByText';
import { LegacyNewsletter, NewsletterUnsubscribe } from '../Forms/Newsletter/Newsletter';
import { ModalByButton } from '../ModalByButton/ModalByButton';
import { OverlayRectangle } from '../OverlayRectangle';
import { Placeholder } from '../Placeholder/Placeholder';
import { SectionSeperator } from '../SectionSeperator/SectionSeperator';
import { Voucher } from '../Voucher/Voucher';
import { Video } from '../Video/Video';
import { BlockText } from '../Footer/BlockText/BlockText';
import { BlockList } from '../Footer/BlockList/BlockList';
import { BlockImage } from '../Footer/BlockImage/BlockImage';
import { BlockBadges } from '../Footer/BlockBadges/BlockBadges';
import { ImageGroup } from '../Footer/ImageGroup/ImageGroup';
import { registerComponents } from './componentRegistry';
import { OverlayCircle } from '../OverlayCircle';

/**
 * Registers a set of components using the previously defined registerComponent function.
 * don't forget to register the dynamic components if <ComponentRecognizer /> is in use. Example:
 * ```
 *    import { registerFlexibleComponents } from '@packages/cms-components/src/components/ComponentRecognizer/registerFlexibleComponents';
 *    registerFlexibleComponents();
 * ```
 */
export const registerFlexibleComponents = (): void => {
  registerComponents({
    [ComponentTypes.Html]: Html,
    [ComponentTypes.Placeholder]: Placeholder,
    [ComponentTypes.Group]: CmsGroup,
    [ComponentTypes.GroupLocalizable]: CmsGroup,
    [ComponentTypes.GroupApp]: CmsGroup,
    [ComponentTypes.SvgFile]: CmsImage,
    [ComponentTypes.ImageSimple]: CmsImage,
    [ComponentTypes.ImageFooter]: CmsImage,
    [ComponentTypes.Headline]: CmsHeadline,
    [ComponentTypes.Accordion]: CmsAccordion,
    [ComponentTypes.AccordionLocalizable]: CmsAccordion,
    [ComponentTypes.LinkByButton]: LinkByButton,
    [ComponentTypes.LinkByText]: LinkByText,
    [ComponentTypes.LinkBox]: LinkBox,
    [ComponentTypes.DynamicYield]: CmsDynamicYield,
    [ComponentTypes.RecoPrudsys]: CmsRecommendation,
    [ComponentTypes.RecoEps]: CmsEpsRecommendation,
    [ComponentTypes.SectionSeperator]: SectionSeperator,
    [ComponentTypes.OverlayCircle]: OverlayCircle,
    [ComponentTypes.OverlayRectangle]: OverlayRectangle,
    [ComponentTypes.InstallmentCalculator]: CmsInstallmentCalculator,
    [ComponentTypes.ButtonModal]: ModalByButton,
    [ComponentTypes.Liveshopping]: ExternalScript,
    [ComponentTypes.ExternalScript]: ExternalScript,
    [ComponentTypes.ExternalScriptHappyContest]: ExternalScript,
    [ComponentTypes.ExternalScriptLoadbee]: ExternalScript,
    [ComponentTypes.Newsletter]: LegacyNewsletter,
    [ComponentTypes.NewsletterUnsubscribe]: NewsletterUnsubscribe,
    [ComponentTypes.VoucherList]: Voucher,
    [ComponentTypes.Video]: Video,
    [ComponentTypes.Carousel]: CmsCarousel,
    [ComponentTypes.BlockText]: BlockText,
    [ComponentTypes.BlockList]: BlockList,
    [ComponentTypes.BlockImage]: BlockImage,
    [ComponentTypes.BlockBadges]: BlockBadges,
    [ComponentTypes.FooterGroupImage]: ImageGroup,
    [ComponentTypes.CategoryTeaser]: CategoryTeaser,
    [ComponentTypes.HermesShopFinder]: HermesShopFinder,
  });
};
